import {
  ImageCoverView,
  ImageScaleView,
  ImageScaleViewOpts,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import StateObserver from 'src/StateObserver';
import { getMatch2FrenzyEventConfig } from 'src/replicant/match2/frenzy/match2-frenzy.getters';
import { getFrenzyObjectiveIcon, getStreakRewardIcon } from '../match2.icons';
import { getCurrentBuruStreakRewardSet } from 'src/replicant/match2/match2.getters';
import { match2BuruStreakRewards } from 'src/replicant/match2/match2.ruleset';

export default class Match2PinchLossPanel extends ImageScaleView {
  constructor(
    opts: Omit<
      ImageScaleViewOpts,
      'image' | 'width' | 'height' | 'centerOnOrigin' | 'centerAnchor'
    > & { objectivesCount: number },
  ) {
    super({
      ...opts,
      width: 253,
      height: 213,
      centerOnOrigin: true,
      centerAnchor: true,
      image: 'assets/ui/match2/common/panel_pinch.png',
    });

    let offsetX = 42;

    const { user } = StateObserver.getState();
    const now = StateObserver.now();
    const config = getMatch2FrenzyEventConfig(user, now);

    if (!config) throw new Error(`No frenzy event config found`);

    getFrenzyObjectiveIcon(config.theme)
      .get()
      .then((image) => {
        new ImageCoverView({
          superview: this,
          image,
          width: 120,
          height: 120,
          centerOnOrigin: true,
          centerAnchor: true,
          mode: 'contain',
          x: this.style.width * 0.5 - offsetX,
          y: this.style.height * 0.5 - 30,
        });
      });

    if (opts.objectivesCount) {
      new LangBitmapFontTextView({
        superview: this,
        font: 'Title',
        color: '#FFFFFF',
        size: 30,
        x: this.style.width * 0.5 - offsetX - 2,
        y: this.style.height * 0.5 - 10,
        centerOnOrigin: true,
        centerAnchor: true,
        localeText: () => `+${opts.objectivesCount}`,
        verticalAlign: 'center',
        align: 'center',
        zIndex: 1,
      });
    }

    offsetX += 10;

    const panel = new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/common/streak_bg.png',
      width: 63,
      height: 61,
      centerOnOrigin: true,
      centerAnchor: true,
      x: this.style.width * 0.5 + offsetX,
      y: this.style.height * 0.5 - 35,
      scale: 1.2,
    });

    getStreakRewardIcon(
      getCurrentBuruStreakRewardSet(user) ?? match2BuruStreakRewards[0],
    )
      .get()
      .then((image) => {
        new ImageScaleView({
          superview: panel,
          image,
          width: panel.style.width,
          height: panel.style.height,
          centerOnOrigin: true,
          x: panel.style.width * 0.5,
          y: panel.style.height * 0.5,
          scale: 0.8,
        });
      });

    new LangBitmapFontTextView({
      superview: this,
      font: 'Body',
      color: '#BF8147',
      size: 22,
      x: this.style.width * 0.5,
      y: 145,
      width: 200,
      centerOnOrigin: true,
      centerAnchor: true,
      localeText: () => i18n(`match2.movesPinch.message2`),
      verticalAlign: 'center',
      align: 'center',
      wordWrap: true,
    });
  }
}
